import axios from 'axios';
import { adminPath, isAdminSubdomain } from '../utils/adminPaths';

// In production the backend serves BOTH the React build and the API on the
// same host, so the API must be called same-origin (relative `/api`). Using an
// absolute URL (e.g. https://example.com/api) breaks whenever the page is
// loaded on a different origin variant such as www.* — the browser blocks the
// cross-origin request via the `connect-src 'self'` CSP. Relative URLs work on
// every origin variant (www / non-www / admin subdomain) with no CORS at all.
const configuredUrl = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
const isLocalhost =
  typeof window !== 'undefined' &&
  /^(localhost|127\.0\.0\.1|\[::1\])$/.test(window.location.hostname);

// Localhost dev: talk to the separate dev API (default :5000).
// Everywhere else: same-origin relative paths.
export const API_BASE_URL = isLocalhost ? configuredUrl : '/api';
export const API_ORIGIN = isLocalhost ? configuredUrl.replace(/\/api\/?$/, '') : '';

export const buildAssetUrl = (url) => {
  if (!url) return '';
  if (/^https?:\/\//i.test(url)) return url;
  if (url.startsWith('/')) return `${API_ORIGIN}${url}`;
  return `${API_ORIGIN}/${url}`;
};

const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 30000,
});

// Handle expired/invalid tokens globally
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const isAuthRoute = error.config?.url?.includes('/auth/login');
      if (!isAuthRoute) {
        localStorage.removeItem('admin_token');
        localStorage.removeItem('admin_user');
        delete api.defaults.headers.common['Authorization'];
        if (isAdminSubdomain || window.location.pathname.startsWith('/admin')) {
          window.location.href = adminPath('/login');
        }
      }
    }
    return Promise.reject(error);
  }
);

export default api;
